import router from '@/router';
import {
  SET_USER,
  CLEAR_USER,
  SET_MINI_LOADING,
  TOGGLE_SNACKBAR,
  SET_BREADCRUMBS,
  CLOSE_SNACKBAR,
  SET_BREAKPOINT,
  SET_COMPANIES,
  SET_TAG_GOODS,
  RESET_TAG_GOODS,
  SET_HOT_SEARCH,
  SET_GOODS_CATEGORY,
  SET_SHOPPING_CART,
  SET_AD_LIST,
  SET_BANNER_LIST,
  SET_WEB_CONFIG,
  SET_USED_COUNTRY,
  SET_SEARCH_IMAGE_GOODS,
  SET_NEWS_LIST,
  SET_LANGUAGE,
} from '../mutation-types';

export default {
  [SET_LANGUAGE](state, payload) {
    state.language = payload;
    localStorage.setItem('language', JSON.stringify(payload));
  },
  [SET_SEARCH_IMAGE_GOODS](state, payload) {
    state.searchImageGoodsList = payload;
  },
  [SET_USED_COUNTRY](state, payload) {
    state.usedCountry = state.webConfig.countryList.find((item) => item.id === payload);
  },
  [SET_AD_LIST](state, payload) {
    state.adList.status = 1;
    state.adList.data = payload;
  },
  [SET_WEB_CONFIG](state, payload) {
    state.webConfig = payload;
  },
  [SET_NEWS_LIST](state, payload) {
    state.newsList = payload;
  },
  [SET_BANNER_LIST](state, payload) {
    state.bannerList.status = 1;
    state.bannerList.data = payload;
  },
  [SET_SHOPPING_CART](state, payload) {
    state.shoppingCart.status = 1;
    state.shoppingCart.data = payload;
  },
  [SET_GOODS_CATEGORY](state, payload) {
    state.categories.status = 1;
    state.categories.data = payload;
  },
  [SET_HOT_SEARCH](state, payload) {
    state.hotSearch.status = 1;
    state.hotSearch.data = payload;
  },
  [SET_TAG_GOODS](state, payload) {
    state.tagGoods[payload.name] = payload;
  },
  [RESET_TAG_GOODS](state, payload) {
    state.tagGoods[payload.name] = {
      status: 0,
      data: [],
      currentPage: 1,
    };
  },
  [SET_COMPANIES](state, payload) {
    state.countries.status = 1;
    state.countries.data = payload;
  },
  [SET_BREAKPOINT](state, payload) {
    state.breakpoint = payload;
    state.mobile = payload.mobile;
  },
  [SET_BREADCRUMBS](state, payload) {
    state.breadCrumbs = payload;
  },
  [SET_USER](state, payload) {
    state.user = payload.data;
    if (payload.account) {
      if (payload.save) {
        this.$cookie.set('account', JSON.stringify(payload.account), { expires: 7 });
      } else {
        this.$cookie.set('account', JSON.stringify(payload.account));
      }
    }
  },
  [CLEAR_USER](state) {
    this.$cookie.remove('account');
    state.user = null;
    router.replace('/');
  },
  [SET_MINI_LOADING](state) {
    state.miniLoading = !state.miniLoading;
  },
  [TOGGLE_SNACKBAR](state, payload) {
    if (payload.type === 'error') {
      state.snackbar.color = 'error';
      state.snackbar.icon = 'mdi-alert-circle';
    } else {
      state.snackbar.color = 'success';
      state.snackbar.icon = 'mdi-check';
    }
    state.snackbar.text = payload.text;
    if (payload.timeout) {
      state.snackbar.timeout = payload.timeout;
    } else {
      state.snackbar.timeout = 3000;
    }
    state.snackbar.show = true;
  },
  [CLOSE_SNACKBAR](state) {
    state.snackbar.show = false;
  },
};
